import { gql } from '@apollo/client';

export const BASIC_FILE_TYPE_FIELDS_FRAGMENT = gql`
    fragment BasicFileTypeFields on FileType {
        FileTypeId
        Name
    }
`;

export const MACHINE_CALIBRATION_FRAGMENT = gql`
    fragment MachineCalibrationFields on MachineCalibration {
        MachineCalibrationId
        Vendor
        CalibrationDate
        ExpirationDate
    }
`;

export const EQUIPMENT_CALIBRATION_FRAGMENT = gql`
    fragment EquipmentCalibrationFields on EquipmentCalibration {
        EquipmentCalibrationId
        Vendor
        CalibrationDate
        ExpirationDate
    }
`;

export const BASIC_FILE_FIELDS_FRAGMENT = gql`
    fragment BasicFileFields on File {
        FileId
        FileName
        ContainerName
        MimeType
        FileData
        Created
    }
`;

export const FR_ENTITY_DOC_RESOURCE_FIELDS = gql`
    fragment fr_EntityDocResourceFields on EntityDocResource {
        ... on File {
            FileId
            FileName
            MimeType
            MachineCalibration {
				CalibrationDate
				ExpirationDate
				Vendor
			}
            EquipmentCalibration {
                CalibrationDate
                ExpirationDate
                Vendor
            }
            Folder {
                FolderId
                Name
                Count
                ParentId
            }
        }
        ... on Folder {
            FolderId
            Name
            Count
            ParentId
        }
    }
`;
